import { useTranslation } from "react-i18next"
import { CarFront } from "lucide-react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"

const CrewBoardSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const enabled = Boolean(useFeatureFlagEnabled("crew-board"))
  if (!enabled) return null
  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.CREW_BOARD}
      icon={CarFront}
      activeIcon={CarFront}
      tooltipText={t("app.sidebar.crews")}
      className={className}
    />
  )
}

export default CrewBoardSidebarButton
